import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, Image, Spinner, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService';
import RegistOrLogin from './RegistOrLogin';
import DynamicDialog from './DynamicDialog';
import UserMark from './UserMark';
import { LoginInfo } from '../App';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const Status = () => {
	async function getStatusList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/server/statusList").then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const {t,i18n} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [checkoutProcess,setCheckoutProcess] = useState(false)
    const [showDialog,setShowDialog] = useState(false)
    const [title,setTitle] = useState("")
    const [message,setMessage] = useState("")
    const [generateList,setGenerateList] = useState([])
    const [commonList,setCommonList] = useState([])
    function dialog(title,message){
        setTitle(title)
        setMessage(message)
        setShowDialog(true)
    }

    function checkDate(dateStr,minutes){
        // Dateオブジェクトに変換できないため、適切な日時を使用します
        const dateToCheck = new Date(dateStr);

        // Dateオブジェクトが有効かチェック
        if (isNaN(dateToCheck.getTime())) {
            console.log("無効な日付形式です。正しい日付を入力してください。");
            return false
        } else {
            // 現在の日時を取得
            const currentDate = new Date();

            // 10分をミリ秒に変換（10分 = 600秒 = 600,000ミリ秒）
            const tenMinutesInMs = minutes * 60 * 1000;

            // 日付の差を計算
            const timeDifference = currentDate - dateToCheck;

            // 日付が現在より10分以上経過しているかをチェック
            if (timeDifference > tenMinutesInMs) {
                return false
            } else {
                return true
            }
        }
    }

	useEffect(() => {
		document.querySelector("title").textContent = "Server Status - アワートAI AIイラスト投稿サイト & AI無料自動生成"
        getStatusList().then(r => {
            if(r.result){
                setGenerateList(r.data.generate.map(d => {
                    d.status = checkDate(d.last_job_request_datetime,10)
                    return d
                }))
                setCommonList(r.data.common.map(d => {
                    d.status = checkDate(d.last_access_datetime,180)
                    return d
                }))
            }
        })
	},[location.pathname])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Image src='/img/ad_ourt.webp' style={{position:"fixed",width:"100%",opacity:0.2,zIndex:-1}} />
        <Dialog show={showDialog} title="" message={message} handleClose={() => setShowDialog(false)} />
        <Container>
            <Container className='text-center'>
                <h1 style={{color:"#444444"}}>Server Status</h1>
            </Container>
            <h3 style={{color:"#444444"}}>生成マシン</h3>
            <Table striped>
                <tbody>
                    <tr><th>GPU ID</th><th>状態</th></tr>
                    {generateList.map(d => <tr><td>{d.server_id}</td><td>{d.status ? <CheckCircleIcon style={{color:"green"}} /> : <ErrorOutlineIcon style={{color:"red"}} />}</td></tr>)}
                </tbody>
            </Table>
            NG条件：10分以上応答がない場合
            <hr />

            <h3 style={{color:"#444444"}}>その他</h3>
            <Table striped>
                <tbody>
                    <tr><th>サーバー名</th><th>状態</th></tr>
                    {commonList.map(d => <tr><td>{d.name}</td><td>{d.status ? <CheckCircleIcon style={{color:"green"}} /> : <ErrorOutlineIcon style={{color:"red"}} />}</td></tr>)}
                </tbody>
            </Table>
            NG条件：3時間以上応答がない場合
        </Container>
        <Footer />
    </div>
    )
}

export default Status;
